import XLSX from 'xlsx';

export function exportXLSX(data = [], title, filename, style=false) {

  const ws = XLSX.utils.aoa_to_sheet(data);
  const wb = XLSX.utils.book_new();

  let wscols = [];
  // const alphabet = ["A","B","C","D","E","F","G","H"]
  if(style) {
    wscols = [{width:40},{width:20},{width:20},{width:20},{width:20},{width:20},{width:30},{width:20}];
    ws['!cols'] = wscols;
    // alphabet.forEach((a, index) => {
    //   let key = a+'1';
    //   if(key in ws) {
    //     ws[key].s = { 
    //       fill: { bgColor: { rgb: "ffe100" } },
    //       alignment: { horizontal: 'center' },
    //     };
    //   }
    // });
  }

  XLSX.utils.book_append_sheet(wb, ws, title);
  /* generate XLSX file and send to client */
  XLSX.writeFile(wb, filename);
}
